import { _ } from 'core-js'

/*
 * @Author:
 * @LastEditTime: 2023-06-20 15:09:29
 * @Description:
 */
let player = null // player示例对象
const initPlayer = async (playerObj) => {
  player = playerObj
}
/**
 * @description:创建标签
 * @param {*} pos 三维世界坐标
 * @param {*} text 标签上显示内容
 * @param {*} length 标签内容长度
 * @param {*} height 标签高度
 * @param {*} bgColor 标签背景颜色
 * @return {*}
 */
const drawTextLabel = async (pos, text, length, height, bgColor, maxLod) => {
  const imgId = await PlayerUtils.call(
    player.Native.GisMarker.loadImage,
    bgColor || `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/tag_info.png`
  )
  const option = {
    pos, // 定位点，世界坐标，三维向量
    visible: true, // 显示隐藏状态
    maxLod: Number(maxLod) || 1000, // 最大可见距离，默认值为最大double值
    // minLod: 0, // 最小可见距离，默认值为最小double值
    size: -1, // 整体尺寸，二维向量，-1表示不限制，自动大小
    //   nodeOffset: [-50, -40], // [-50, -40], // 相对定位点的偏移量，二维向量
    nodeOffset: [(-1 * (length * 5 - 40)) / 2, -1 * height * 24 - 10], // 相对定位点的偏移量，二维向量
    text, // 文本
    imgId,
    imgSize: [-1, -1], // 图片尺寸，-1为应用图片大小，如[32, -1]为宽度拉伸或压缩到32，高度为图片高度
    //   imgOffset: [0, 0], // 图片相对标记的偏移量
    imgOffset: [(-1 * (length * 5)) / 2, -1 * height * 24], // 图片相对标记的偏移量
    fontSize: 14.0, // 字体大小
    breakWidth: -1, // 最大行宽，超过宽度会换行，-1表示限制，换行符（'\n'）会强制换行不受控制
    contentPadding: [5, 10, 5, 10], // 文字相对标记的偏移量
    textColor: 0xffffffff, // 文本颜色
    title: '', // 标题
    titleFontSize: 14.0, // 标题文字大小
    titleColor: 0xffffffff, // 标题颜色
    userData: null, // 用户数据，仅帮外部系统保存数据
  }
  // option里面的类容均为可选，但是option至少是{}，不能为null
  const markerId = await PlayerUtils.call(player.Native.GisMarker.create, option)
  return markerId
}
const drawMarker = async (pos, imgId, imgSize, size, nodeOffset = [0, 0]) => {
  const option = {
    pos, // 定位点，世界坐标，三维向量
    visible: true, // 显示隐藏状态
    // maxLod: 200, // 最大可见距离，默认值为最大double值
    // minLod: 0, // 最小可见距离，默认值为最小double值
    size: -1, // 整体尺寸，二维向量，-1表示不限制，自动大小
    size, // 整体尺寸，二维向量，-1表示不限制，自动大小
    nodeOffset, // 相对定位点的偏移量，二维向量
    imgId, // 图片
    imgSize: imgSize, // 图片尺寸，-1为应用图片大小，如[32, -1]为宽度拉伸或压缩到32，高度为图片高度
    imgOffset: [0, 0], // 图片相对标记的偏移量
    text: '', // 文本
    fontSize: 14.0, // 字体大小
    breakWidth: -1, // 最大行宽，超过宽度会换行，-1表示限制，换行符（'\n'）会强制换行不受控制
    textOffset: [0, 0], // 文字相对标记的偏移量
    textColor: 0xffffffff, // 文本颜色
    title: '', // 标题
    titleFontSize: 18.0, // 标题文字大小
    titleColor: 0xffffffff, // 标题颜色
    userData: null, // 用户数据，仅帮外部系统保存数据
  }
  const markerId = await PlayerUtils.call(player.Native.GisMarker.create, option)
  return markerId
}
/**
 * @description:
 * @param {*} markerInfos 卸载的标签合集
 * @return {*} 卸载标签
 */
const destroyMarker = async (markerInfos) => {
  // 检查是否有已知的标记
  const markerList = await PlayerUtils.call(player.Native.GisMarker.getMarkerList)
  _.forEach(markerList, (el) => {
    if (_.findIndex(markerInfos, ['markerId', el.id]) !== -1) {
      player.Native.GisMarker.destroy(el.id)
    }
  })
}
/**
 * @description:
 * @param {*} markerId 编辑节点
 * @param {*} options 更新的配置项
 * @return {*}
 */
const updateMarker = async (markerId, options) => {
  await player.Native.GisMarker.update(markerId, options)
}
const moveToCode = async (params) => {
  const itemInfo = await player.Native.ModelTree.getItemByCode(params.kks)
  const response = {
    method: 'iframeSelectDevice',
    token: params.token,
    success: true,
    params: {},
  }
  if (_.keys(itemInfo).length) {
    const { aabb, localMatrix } = await player.Native.ModelTree.calcItemAabb(itemInfo.item)
    player.Native.ModelTree.setSelectItemNoEvent(itemInfo.item)
    player.Native.Camera.moveToAabb(aabb, localMatrix, 1, 1.1, 2)
  } else {
    response.success = false
  }
  window.parent.postMessage(response, '*')
}
/**
 * @description: 通过code获取对应Item的世界坐标
 * @param {*} code 模型code
 * @return {*}
 */
const getItemPosByCode = async (code) => {
  const pos = []
  const resPtr = await PlayerUtils.call(player.Native.ModelTree.calcItemAabb, code)
  if (!_.isEmpty(resPtr)) {
    pos[0] = 1 * resPtr.aabb.min[0] + (resPtr.aabb.max[0] - resPtr.aabb.min[0]) / 2 // x坐标
    pos[1] = 1 * resPtr.aabb.min[1] + (resPtr.aabb.max[1] - resPtr.aabb.min[1]) / 2 // y坐标
    pos[2] = 1 * resPtr.aabb.min[2] + (resPtr.aabb.max[2] - resPtr.aabb.min[2]) / 2 // z坐标
  }
  return pos
}
export {
  initPlayer,
  moveToCode,
  destroyMarker,
  updateMarker,
  drawTextLabel,
  drawMarker,
  getItemPosByCode,
}
